import { HttpClient, HttpEvent, HttpEventType, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, of, tap, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiResponse } from '../model/commonModel';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from './api-url-helper/api-url-helper';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private apiUrl: ApiUrlHelper,
  ) {}

  notifyAgent(customerId: any): Observable<ApiResponse> {
    const url = this.apiUrl.apiUrl.myRequest.notifyAgent.replace(
      '{customerId}',
      customerId,
    );
    return this.doPost(url, null);
  }

  doGet(ApiUrl: String): Observable<ApiResponse> {
    const url = `${environment.apiUrl}${ApiUrl}`;
    return this.http.get<ApiResponse>(url).pipe(
      tap(() => this.log(`doGet success`)),
      catchError((error: any) => {
        let errorMessage = this.getAPIErrorMessage(error);

        return throwError(() => ({
          Data: null,
          Message: errorMessage,
          Success: false,
          TAID: '',
        }));
      })
    );
  }

  saveFileWithProgress(ApiUrl: string, postData: any): Observable<HttpEvent<ApiResponse>> {
    const url = `${environment.apiUrl}${ApiUrl}`;
    return this.http.post<ApiResponse>(url, postData, { reportProgress: true, observe: 'events' }).pipe(
      tap(() => this.log(`doPost success`)),
      catchError((error: any) => {
        let errorMessage = this.getAPIErrorMessage(error);

        return throwError(() => ({
          Data: null,
          Message: errorMessage,
          Success: false,
          TAID: '',
        }));
      })
    );
  }

  doPost(ApiUrl: string, postData: any): Observable<ApiResponse> {
    const url = `${environment.apiUrl}${ApiUrl}`;
    return this.http.post<ApiResponse>(url, postData).pipe(
      tap(() => this.log(`doPost success`)),
      catchError((error: any) => {
        let errorMessage = this.getAPIErrorMessage(error);

        return throwError(() => ({
          Data: null,
          Message: errorMessage,
          Success: false,
          TAID: '',
        }));
      })
    );
  }

  doDelete(apiUrl: String, datatoDelete: any): Observable<ApiResponse> {
    const options = {
      body: datatoDelete
    };
    const url = `${environment.apiUrl}${apiUrl}`;
    return this.http.delete<ApiResponse>(url, options).pipe(
      tap(() => this.log(`doDelete success`)),
      catchError((error: any) => {
        let errorMessage = this.getAPIErrorMessage(error);

        return throwError(() => ({
          Data: null,
          Message: errorMessage,
          Success: false,
          TAID: '',
        }));
      })
    );
  }

  doDownloadPost(ApiUrl: string, postData: any) {
    // const httpOptions = {
    //   headers: new HttpHeaders()
    // };
    // let loginData = localStorage.getItem('authToken');
    // if (loginData) {
    //   httpOptions.headers = httpOptions.headers.set('Authorization', 'Bearer ' + loginData);
    //   httpOptions.headers = httpOptions.headers.set('Access-Control-Allow-Methods', '*');
    // }
    const url = `${environment.apiUrl}${ApiUrl}`;
    return this.http.post(url, postData, { observe: "response", responseType: "blob" })
      .pipe()
      .subscribe({
        next: (response) => {
          // Extract filename from headers
          let filename = response.headers
            .get('content-disposition')
            ?.split(';')[1]
            .split('=')[1]
            .trim()
            .replace(/^"|"$/g, '');

          // Create a Blob and trigger download
          let blob: Blob = response.body ?? new Blob();
          let a = document.createElement('a');
          a.download = filename ?? 'downloaded_file.xlsx';
          a.href = window.URL.createObjectURL(blob);
          a.click();

          this.toastr.success('File downloaded successfully!', 'Success');
        },
        error: (err) => {
          console.error('Download error:', err);
          this.toastr.error('Failed to download file. Please try again.', 'Error');
        },
      });
  }

  GetLocationData(): Observable<any> {
    return this.http.get<any>('https://ipapi.co/json/').pipe(
      map(response => response.country_name), // e.g. 'IN', 'US'
      catchError(() => of('United States Of America')) // fallback to US on error
    );
  }

  /** Log a HeroService message with the MessageService */
  private log(message: string) {
    console.log("Log from service : " + message);
  }

  getAPIErrorMessage(error: any): string {
    let errorMessage = "Something went wrong. Please try again after sometime.";

    if (error.status === 400 && error.error?.errors) {
      // Extract validation errors and format them
      errorMessage = Object.keys(error.error.errors)
        .map((key) => error.error.errors[key].join(" ")) // Corrected syntax
        .join(" | ");
    }

    return errorMessage;
  }
}
